module.exports = __webpack_public_path__ + "static/media/Ativo-1@4x.f98b35c6.png";